import { Modal, Button } from 'react-bootstrap';

interface ModalProps {
  show: boolean;
  message: string[];
  onSim?: (entidade: any) => void;
  onNao?: () => void;
  onHide?: () => void;
  ehDeSimNao?: boolean;
};

function ModalAlerta(props: ModalProps) {
  const title = props.ehDeSimNao ? 'Confirmação' : 'Atenção';

  const handleNaoClick = () => {
    if (props.onNao) {
      props.onNao();
    }
    if (props.onHide) {
      props.onHide();
    }
  };

  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button type='button' className='btn-close' aria-label='Close' onClick={props.onHide} />
      </Modal.Header>
      <Modal.Body role='alert'>
        {props.message?.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
        {props.ehDeSimNao && 
          <div className="d-flex justify-content-end mt-3">
            <Button variant="success" onClick={props.onSim} className="me-2">
              Sim
            </Button>
            <Button variant="danger" onClick={handleNaoClick}>
              Não
            </Button>
          </div>
        }
      </Modal.Body>
    </Modal>
  );
}

export default ModalAlerta;
